import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import "./Sidenav.scss";
import payin64 from "../../../assets/images/icons/pay-in/payin64.png";
import payout64 from "../../../assets/images/icons/pay-out/payout64.png";
import dashboard64 from "../../../assets/images/icons/dashboard/dashboard64.png";
import order from "../../../assets/images/icons/pay-out/Orders.png";
import products from "../../../assets/images/icons/pay-out/Products.png";
import payments from "../../../assets/images/icons/pay-out/Payments.png";
import settings from "../../../assets/images/icons/pay-out/Settings.png";
import isuesAndGrievance from "../../../assets/images/icons/pay-out/issue grievance.png";
import marketing from "../../../assets/images/icons/pay-out/Marketing.png";
import helpAndSupport from "../../../assets/images/icons/pay-out/Help & Support.png";
import reportsAndMis from "../../../assets/images/icons/report/report_mis.png";

import { NavLink, Link, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { FaCrown } from "react-icons/fa";

// import { useDedupCall } from "../../Common/CustomeHooks/useDedupCall";

// import userLogo from "../../../assets/images/EasyPayOndcLogo.png";
import userLogo from "../../../assets/images/easypaylogoblack.png";
import useKycDedupe from "../../Common/CustomeHooks/useKycDedupe";
import AuthContext from "../../../Store/auth-context";
import InProgressPopup from "../../Common/InProgressPopup/InProgressPopup";
import { RiMenu2Line } from "react-icons/ri";
import { BiChevronsLeft, BiChevronsRight } from "react-icons/bi";
// import Spinner from "../../Common/Loading/Spinner";
import sbiYonoMotionBanner from "../../../assets/images/SBI_Yono_Motion_banner.gif"
import { addSellerEventUrl } from "../../Services/Constant";
import { HTTPSDIRECT } from "../../../services/HTTPS";
import { toast } from "react-toastify";

const Sidenav = () => {
  const { t } = useTranslation();
  // let userLogo = sessionStorage.getItem("partnerLogo");
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const { dedupCall, loader } = useKycDedupe();
  // const [loading, setLoading] = useState(false);
  const authCtx = useContext(AuthContext);
  const loginData = authCtx?.authData;
  const [logo, setLogo] = useState(userLogo);
  const [logo2, setLogo2] = useState(userLogo);
  const popupRef = useRef(null);
  const [isMaximized, setIsMaximized] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  // Sidebar menu returned by the login API (doSellerLogin -> DATA.menuList)
  const bySeq = (a, b) => a.displaySequence - b.displaySequence;
  const menuList = [...(loginData?.menuList || [])].sort(bySeq);

  // Backend sends no icons, so map them by menuCode
  const MENU_ICONS = {
    DASHBOARD: dashboard64,
    ORDERS: order,
    PRODUCTS: products,
    QUOTATION: reportsAndMis,
    PAYMENTS: payments,
    SETTINGS: settings,
    CUSTOMER_ISSUE: isuesAndGrievance,
    MARKETING: marketing,
    HELP_SUPPORT: helpAndSupport,
    REPORTS_MIS: reportsAndMis,
    LOANS: payments,
    UPGRADE_PLAN: payments,
  };

  // Match by menuCode first, then by menuName ("Help & Support" -> HELP_SUPPORT)
  const getIconKey = (menu) => {
    const nameKey = (menu.menuName || "")
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, "_")
      .replace(/^_|_$/g, "");
    if (menu.menuCode === "PRO" || nameKey === "PRO") return "PRO";
    if (MENU_ICONS[menu.menuCode]) return menu.menuCode;
    return MENU_ICONS[nameKey] ? nameKey : null;
  };

  const renderMenuIcon = (menu) => {
    const key = getIconKey(menu);
    if (key === "PRO") {
      return (
        <span className="menu-img menu-img-pro">
          <FaCrown />
        </span>
      );
    }
    return (
      <img className="menu-img" src={MENU_ICONS[key] || payments} alt="" />
    );
  };

  // Link for each menu comes from MENU_MST.REDIRECTION_PATH (login API)
  const getMenuPath = (menu) => menu.redirectionPath?.trim() || "";

  const getExternalUrl = (menu) =>
    getMenuPath(menu).startsWith("http") ? getMenuPath(menu) : null;

  // Seller events logged when loan partner links are clicked
  const LOAN_EVENTS = {
    BUSINESS_LOAN: "BUSINESSLOAN-INDIFI",
    PERSONAL_LOAN: "PERSONALLOAN-ONDC",
    GOLD_LOAN: "GOLDLOAN-ONDC",
  };

  // Existing nav.* translation keys for each menuCode; unknown codes show menuName
  const MENU_LABEL_KEYS = {
    DASHBOARD: "dashboard",
    ORDERS: "orders",
    MY_ORDERS: "myOrders",
    SHIPMENTS: "shipments",
    RETURNS: "returns",
    BULK_INVOICE: "bulkInvoice",
    PRODUCTS: "products",
    MY_PRODUCTS: "myProducts",
    ADD_PRODUCT: "addProduct",
    MY_VARIANTS: "myVariants",
    ADD_VARIANT: "addVariant",
    BULK_EDIT: "bulkEdit",
    QUOTATION: "quotation",
    QUOTATION_PROFILE: "Profile",
    QUOTATION_CATEGORIES: "catogories",
    QUOTATION_PRODUCTS: "products",
    QUOTATION_QUOTATION: "quotation",
    QUOTATION_MY_WEBSITE: "myWebsite",
    QUOTATION_CUSTOMER: "quotationCustomer",
    PAYMENTS: "payments",
    SETTLEMENTS: "settlements",
    ADJUSTMENTS: "adjustments",
    CREDIT_LEDGER: "creditLedger",
    SETTINGS: "settings",
    BUYER_ACTIVATION: "buyerActivation",
    LSP_ACTIVATION: "lspActivation",
    SETTINGS_MANAGE_STORE: "manageStore",
    SETTINGS_MANAGE_USER: "manageUser",
    CUSTOMER_ISSUE: "customerIssue",
    ISSUES: "issues",
    MARKETING: "marketing",
    OFFERS: "offers",
    STORE_QR: "storeQr",
    MY_CUSTOMERS: "myCustomers",
    HELP_SUPPORT: "helpSupport",
    HELP_PROFILE: "profile",
    FAQ: "faq",
    HELP: "help",
    CONTACT_US: "contactUs",
    TERMS: "terms",
    FEES: "fees",
    REPORTS_MIS: "reportsMis",
    DOWNLOADS: "downloads",
    LOANS: "loans",
    BUSINESS_LOAN: "businessLoan",
    PERSONAL_LOAN: "personalLoan",
    GOLD_LOAN: "goldLoan",
    UPGRADE_PLAN: "upgradePlan",
  };

  const getMenuLabel = (menu) => {
    const key = MENU_LABEL_KEYS[menu.menuCode];
    return key ? t(`nav.${key}`, { defaultValue: menu.menuName }) : menu.menuName;
  };

  const showComingSoon = (event) => {
    event.preventDefault();
    setShowPopup(true);
  };

  const toggleMenu = (menuCode) => {
    setOpenMenu((prev) => (prev === menuCode ? null : menuCode));
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };

    if (showPopup) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showPopup]);

  const addIconsOnlyClass = () => {
    const list = document.body.classList;
    list.toggle("sidenav-icon-only");
    setIsMaximized(!isMaximized);
  };

  // useEffect(() => {
  //   let submenus = document.getElementsByClassName("sub-menu-content");
  //   // submenus?.[0]?.classList?.add("show");
  // }, []);

  // Close all sidenav submenu when clicked outside
  // window.addEventListener("click", (event) => {
  //   let sidenav = document.getElementById("sidenav");
  //   if (sidenav) {
  //     if (!event.target.closest(".nav-area")) {
  //       navArea();
  //     }
  //     if (!event.target.closest(".right-nav-toggler")) {
  //       sideNavArea(sidenav, event);
  //     }
  //   }
  // });

  const navArea = () => {
    let submenus = document.getElementsByClassName("sub-menu-content");
    for (const element of submenus) {
      let openSubmenu = element;
      if (openSubmenu.classList.contains("show")) {
        openSubmenu.classList.remove("show");
      }
    }
  };

  const sideNavArea = (sidenav, event) => {
    if (!event.target.closest(".open-submenu-btn")) {
      if (sidenav.classList.contains("right-nav")) {
        sidenav.classList.remove("right-nav");
      }
    }
  };

  // const handleNavLinkClick = (event) => {
  //   if (!event.currentTarget.getAttribute("to")) {
  //     event.preventDefault();
  //     // Handle the click event for the NavLink with empty 'to' prop
  //     // Add your custom logic here
  //   }
  // };

  const handleNavLinkClick = (event) => {
    const toAttr = event.currentTarget.getAttribute("to");
    if (!toAttr || toAttr.trim() === "#") {
      event.preventDefault();
      setShowPopup(true);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  const sellerDetails = async () => {
    // dedupCall();
  };

  useEffect(() => {
    const partnerLogo = sessionStorage.getItem("partnerLogo");
    const partnerLogo2 = sessionStorage.getItem("partnerLogo2");
    setLogo(partnerLogo || userLogo);
    setLogo2(partnerLogo2 || userLogo);
  }, [userLogo]);

  const handleSellerEvent = async (category, eventName) => {
    if (!loginData?.sellerMobile) return;

    const requestPayload = {
      HEADER: {
        mobile: loginData.sellerMobile,
        sellerCode: loginData.sellerCode,
      },
      DATA: {
        eventCategory: category,
        eventName: eventName,
      },
    };

    try {
      const response = await HTTPSDIRECT(addSellerEventUrl, requestPayload);
      if (response.RESP_CODE === 300) {
        console.log(response);
      } else {
        console.log(response.RESP_MSG);
        // toast.error(response?.RESP_MSG);
      }
    } catch (error) {
      // toast.error("An error occurred. Please try again later.");
      console.log(error);

    }
  };

  return (
    <Fragment>
      <nav id="sidenav">
        <div className="sidenav-brand-wrapper fixed-top d-none d-lg-flex justify-content-center align-items-center sidenav-mini">
          <Link to="/">
            <div className="brand-logo">
              <img height="50" src={logo} alt="logo" />
            </div>
            <div className="brand-logo-mini">
              <img height="28" src={logo2} alt="logo" />
            </div>
          </Link>
        </div>
        <ul className="navbar-nav nav-area">
          {menuList.map((menu) =>
            menu.subMenuList?.length ? (
              <li className="nav-item" key={menu.menuCode}>
                <div
                  className="nav-link open-submenu-btn"
                  onClick={() => toggleMenu(menu.menuCode)}
                >
                  <span className="menu-icon">{renderMenuIcon(menu)}</span>
                  <span className="menu-title">
                    {getMenuLabel(menu)}
                    <span id="down-arrow" className="arrow">
                      <IoIosArrowDown />
                    </span>
                  </span>
                </div>
                <div
                  className={`sub-menu-content ${openMenu === menu.menuCode ? "show" : ""
                    }`}
                >
                  <ul className="navbar-nav sub-menu">
                    {[...menu.subMenuList].sort(bySeq).map((sub) => (
                      <li className="sub-nav-item" key={sub.menuCode}>
                        {getExternalUrl(sub) ? (
                          <a
                            href={getExternalUrl(sub)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="sub-nav-link"
                            onClick={() =>
                              LOAN_EVENTS[sub.menuCode] &&
                              handleSellerEvent("LOAN", LOAN_EVENTS[sub.menuCode])
                            }
                          >
                            {getMenuLabel(sub)}
                          </a>
                        ) : !getMenuPath(sub) ? (
                          // No path configured yet: an empty NavLink would match every page
                          <a
                            href="#"
                            className="sub-nav-link"
                            onClick={showComingSoon}
                          >
                            {getMenuLabel(sub)}
                          </a>
                        ) : (
                          <NavLink
                            to={getMenuPath(sub)}
                            className="sub-nav-link"
                          >
                            {getMenuLabel(sub)}
                          </NavLink>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ) : (
              // Top-level menu without children links directly
              <li className="nav-item" key={menu.menuCode}>
                <NavLink
                  to={getMenuPath(menu) || "#"}
                  className="nav-link"
                  onClick={!getMenuPath(menu) ? showComingSoon : undefined}
                >
                  <span className="menu-icon">{renderMenuIcon(menu)}</span>
                  <span className="menu-title">
                    {getMenuLabel(menu)}
                  </span>
                </NavLink>
              </li>
            )
          )}

          <li className="nav-item">
            <div
              className="nav-link open-submenu-btn"
              onClick={addIconsOnlyClass}
            >
              <span className="menu-icon">
                <button className="navbar-toggler">
                  {isMaximized ? (
                    <BiChevronsRight className="expand-arrow" />
                  ) : (
                    <BiChevronsLeft className="compress-arrow" />
                  )}
                </button>
              </span>
              <span className="menu-title">
                {isMaximized ? t("nav.expand") : t("nav.collapse")}
              </span>
            </div>
          </li>
          <div className="nav-item">
            <div className="menu-title">
              <a
                href="https://corp.sbi.bank.in/vkyccao/vkycoaolanding.htm"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  handleSellerEvent("BANK", "BANKACCOUNT-CURRENTACCOUNT-SBI")
                }
              >
                <img
                  src={sbiYonoMotionBanner}
                  alt="sbiYonoMotionBanner"
                  className="sbi-yono-motion-banner"
                />
              </a>
            </div>
          </div>

          {/* <div className="compress-menu">
            <button className="navbar-toggler" onClick={addIconsOnlyClass}>
              <div className="arrow-container">
                {isMaximized ? (
                  <BiChevronsRight className="expand-arrow" />
                ) : (
                  <BiChevronsLeft className="compress-arrow" />
                )}
                <span className="compress-tool">
                  {isMaximized ? "Expand" : "Collapse"}
                </span>
              </div>
            </button>
          </div> */}
        </ul>
      </nav>
      {showPopup && (
        <InProgressPopup onClose={closePopup}>
          <p>This feature is available soon. Please check back later!</p>
        </InProgressPopup>
      )}
    </Fragment>
  );
};

export default Sidenav;
